<template>
  <div>
    <div class="content">
      <div class="columns">
        <div class="column is-four-fifth" v-if="paper && paper.title">
          <h6 class="title">{{paper.title}}</h6>

          <div class="tablecard">
            <table>
              <tbody>
                <tr>
                  <td>Authors</td>
                  <td>
                    {{
                      paper.authors &&
                      paper.authors.map((author) => author.name).join(', ')
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Topics</td>
                  <td>
                    {{
                      paper.mainTopics && paper.mainTopics.map(topic => topicOptions[topic]).join(', ')
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Year</td>
                  <td>
                    {{
                      paper.year
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Category</td>
                  <td>
                    {{
                      paper.category && categoryOptions[paper.category]
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Tags</td>
                  <td>
                    {{
                      paper.tags && paper.tags.map(tag => topicOptions[tag.name]).join(',')
                    }}
                  </td>
                </tr>
                <tr>
                  <td>SDGs</td>
                  <td>
                    {{
                      //paper.sdgs && paper.sdgs.map(sdgs => getSDGs(paper)[sdgs]).join(', ')
                      paper.sdgs && getSDGs(paper).join(', ')
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Region</td>
                  <td>
                    {{
                      paper.region && regionOptions[paper.region]
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Available</td>
                  <td>
                    {{
                      paper.available ? "Yes" : "No"
                    }}
                  </td>
                </tr>
                <tr>
                  <td>Link</td>
                  <td>
                    {{
                      paper.url
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="field is-horizontal">
            <div class="field-body">
              <div class="field">
                <p class="control">
                  <!--<input class="input is-static" :value="paper.document" readonly />-->
                  <a v-if="paper.document !== ''" v-on:click="redirectToPDF(paper)">
                    View PDF
                  </a>
                </p>
              </div>
            </div>
          </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from '@/components/Admin/Menu'
import { PAPER_DETAILS_QUERY } from '@/graphql'
import { topicOptions, categoryOptions, languageOptions, regionOptions, sdgOptions } from '@/options'

export default {
  name: 'PaperDetails',
  sdgOptions: sdgOptions,
  components: {
    Menu
  },
  data () {
    return {
      paper: undefined,
      id: parseInt(this.$route.params.id),
      topicOptions: topicOptions,
      categoryOptions: categoryOptions,
      languageOptions: languageOptions,
      regionOptions: regionOptions,
      sdgOptions: sdgOptions
    }
  },
  apollo: {
    // fetch user by ID
    paper: {
      query: PAPER_DETAILS_QUERY,
      variables () {
        return {
          id: this.id
        }
      },
      error (errorDetails) {
        if (errorDetails.message.includes('Authentication Failure') || errorDetails.message.includes('Signature has expired')) {
          localStorage.removeItem('app-token')
          this.$router.push('/login')
        }
      }
    }
  },
  methods: {
    redirectToUrl: function (paper) {
      window.location.href = paper.url
    },
    redirectToPDF: function (paper) {
      const MINIO_STORAGE_ENDPOINT = 'https://docs-s3.infra.hedera.online'
      const MINIO_STORAGE_MEDIA_BUCKET_NAME = 'online-papers-library'
      window.location.href = `${MINIO_STORAGE_ENDPOINT}/${MINIO_STORAGE_MEDIA_BUCKET_NAME}/${paper.document}`
    },
    getSDGs: function (paper) {
      const sdgsNames = [];
      (paper.sdgs || []).forEach(element => {
        sdgsNames.push(sdgOptions.find(e => e.value === element).name)
      })
      return sdgsNames
    }
  }
}
</script>
<style scoped>
.is-four-fifth{
  width: 80vh;
  padding: 2rem;
}
.title{
  color: #41824F;
  font-weight: bold;
  font-size: 2.5rem;
}
.label{
  background-color: #fcc30b;
  font-size: 1.5rem;
  text-align: center;
  border-radius: 100px;
}
.input{
  font-size: 1.5rem;
}
.control{
  font-size: 1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Papers/PaperDetails.vue